import { ChakraProvider, theme } from '@chakra-ui/react'
import axios from 'axios';
import './app.css'
import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  HStack,
  Stack,
  IconButton,
  Input,
  SkeletonText,
  Text,
  Image,
  InputGroup,
  InputRightElement
} from '@chakra-ui/react';
import { FaLocationArrow, FaTimes } from 'react-icons/fa';
import {
  useJsApiLoader,
  GoogleMap,
  InfoWindow,
  Marker,
  Autocomplete,
  DirectionsRenderer,
  Polygon,
} from '@react-google-maps/api';

import { useParams, useLocation } from 'react-router-dom';
import {
  setKey,
  setDefaults,
  setLanguage,
  setRegion,
  fromAddress,
  fromLatLng,
  fromPlaceId,
  setLocationType,
  geocode,
  RequestType,
} from "react-geocode"; //may delete this since not working


//import { MarkerClusterer } from "@googlemaps/markerclusterer"
import { MarkerClusterer } from '@react-google-maps/api';



import parkingicon from './image/parkinglot.png'
import redparkingicon from './image/redmarker.png'
import privateparkingloticon from './image/privatelot.png'
import locicon from './image/map pointer.png'
import caricon from './image/car.png'
import carLeftIcon from './image/carleft.png';
import carRightIcon from './image/carright.png';
import carUpIcon from './image/carup.png';
import carDownIcon from './image/cardown.png';
import carVector from './image/carvector.svg'
import greenClustericon from './image/greencluster.png'
import redClustericon from './image/clustericon.png'
import distanceIcon from './image/distanceicon.png'
import durationIcon from './image/durationicon.png'
import Question from './components/Question';



const center = { lat: 48.8565, lng: 2.3064 };








const libraries = ['places', 'drawing', 'geometry'];

function App() {





  const [mapcenter, setCenter] = useState(center);
  const [countryLang, setCountryLang] = useState('fr');

  var parkingLotCoords = [
    { lat: 48.8246079815396000, lng: 2.3236926739572000 }
  ];

  const api = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  setKey(api); //needs to be removed if encode method not used
  const backendapi = process.env.REACT_APP_BACKEND_API;
  const privateParkingDBAPI = process.env.REACT_APP_PRIVATE_PARKING_DB_API;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: libraries,
  });

  const [questionaire, setQuestionaire] = useState(true);

  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [directionsParkingResponse, setDirectionsParkingResponse] = useState(null);
  const [distance, setDistance] = useState('');
  const [duration, setDuration] = useState('');
  const originRef = useRef();
  const destiantionRef = useRef();
  const [name, setName] = useState('');
  const [parkingLot, setParkingLot] = useState(null);
  const [parkingLotCoordinates, setParkingLotCoordinates] = useState(null);
  const [selectedParkingLot, setSelectedParkingLot] = useState(null);
  const [parkingLots, setParkingLots] = useState([]);
  const [carIcon, setCarIcon] = useState(carUpIcon);
  const [bearing, setBearing] = useState();
  const [querysrc, setSrc] = useState();
  const [querydest, setDest] = useState();

  const markerClustererRef = useRef();

  const [availableparkingLots, setAvailableParkingLots] = useState([]);
  const [unavailableparkingLots, setUnavailableParkingLots] = useState([]);

  const [privateParkingLots, setPrivateParkingLots] = useState([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract source and destination from the query parameters
  const source = queryParams.get('source');
  const destination = queryParams.get('destination');



  useEffect(() => {
    const computeRoute = async (src, dest) => {
      setQuestionaire(false);
      /* setSrc(src);
      setDest(dest); */
      originRef.current.value = src;
      destiantionRef.current.value = dest;
      return calculateRoute();

    };

    if (source && destination) {
      return computeRoute(source, destination);
    } else {
      console.log('no params found');
    }

  }, [map]);







  useEffect(() => {
    // Fetch all parking lots when the component mounts
    fetchAllPrivateParkingLots();
    fetchAllParkingLots();
  }, []);

  const fetchAllParkingLots = async () => {
    try {

      let nextUrl = backendapi;

      while (nextUrl) {
        const response = await axios.get(nextUrl);
        const newParkingLots = response.data.results;

        // Add new parking lots to the existing ones
        //setParkingLots((prevParkingLots) => [...prevParkingLots, ...newParkingLots]);
        const availableParkingLots = newParkingLots.filter((lot) => lot.status === true);
        const unavailableParkingLots = newParkingLots.filter((lot) => lot.status === false);

        // Add new parking lots to the existing ones
        setAvailableParkingLots((prevLots) => [...prevLots, ...availableParkingLots]);
        setUnavailableParkingLots((prevLots) => [...prevLots, ...unavailableParkingLots]);

        //allParkingLots = [...allParkingLots, ...response.data.results];
        nextUrl = response.data.next;
      }

      //setParkingLots(allParkingLots);

    } catch (error) {
      console.error('Error fetching parking lots:', error);
    }
  };

  const fetchAllPrivateParkingLots = async () => {
    try {

      let nextUrl = privateParkingDBAPI;

      while (nextUrl) {
        const response = await axios.get(nextUrl);
        const newParkingLots = response.data.results;

        // Add new parking lots to the existing ones
        setPrivateParkingLots((prevParkingLots) => [...prevParkingLots, ...newParkingLots]);

        nextUrl = response.data.next;
      }

      //setParkingLots(allParkingLots);

    } catch (error) {
      console.error('Error fetching parking lots:', error);
    }
  };




  // Helper function to calculate bearing between two points
  function calculateBearing(startLocation, endLocation) {
    const lat1 = startLocation.lat();
    const lon1 = startLocation.lng();
    const lat2 = endLocation.lat();
    const lon2 = endLocation.lng();

    const dLon = lon2 - lon1;
    const y = Math.sin(dLon) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    let brng = Math.atan2(y, x);
    brng = (brng * 180) / Math.PI;
    brng = (brng + 360) % 360;
    setBearing(brng);
    return brng;
  }


  function calculateRotation(begin, end) {
    const lat = Math.abs(begin.lat - end.lat());
    const lng = Math.abs(begin.lng - end.lng());

    if (begin.lat < end.lat() && begin.lng < end.lng())
      return (Math.atan(lng / lat) * 180) / Math.PI;
    else if (begin.lat >= end.lat() && begin.lng < end.lng())
      return (90 - (Math.atan(lng / lat) * 180) / Math.PI) + 90;
    else if (begin.lat >= end.lat() && begin.lng >= end.lng())
      return (Math.atan(lng / lat) * 180) / Math.PI + 180;
    else if (begin.lat < end.lat() && begin.lng >= end.lng())
      return (90 - (Math.atan(lng / lat) * 180) / Math.PI) + 270;

    return -1;
  }

  // Helper function to get car icon based on bearing
  async function getCarIconByBearing(bearing) {
    // Number of different images available for rotation
    const numImages = 360;

    // Calculate the index of the image based on the bearing
    const imageIndex = Math.round((bearing % 360 + 360) % 360); // Ensure positive angle

    // Assuming your images are named cardeg0, cardeg1, ..., cardeg359
    const imageName = `cardeg${imageIndex}.png`; // Adjust the file extension as needed

    // Construct the path to the image
    const carpic = await import(`./image/carrotate/cardeg${imageIndex}.png`);
    //setCarIcon(carpic.default);
    // Return the image path
    //return imagePath;
    console.log(carpic.default);

  }

  // Function to get the city name from the address
  async function getCityName(address) {
    const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${api}`);
    const city = response.data.results[0].address_components.find(component =>
      component.types.includes('locality')
    );
    return city ? city.long_name : null;
  }

  // Function to check if the city is Paris or New York
  function isCityIncluded(city) {
    return city === 'Paris' || city === 'New York';
  }

  async function calculateRoute() {
    let lotname;
    if (originRef.current.value === '' || destiantionRef.current.value === '') {
      return;
    }

    // Use geocoding service to get the city of the origin and destination
    const originCity = await getCityName(originRef.current.value);
    const destinationCity = await getCityName(destiantionRef.current.value);

    // Check if the cities are Paris or New York
    if (!isCityIncluded(originCity) || !isCityIncluded(destinationCity)) {
      alert("The following city isn't included in our database");

    }

    //using ecode lib to get lat lng of origin func start
    let originobj;
    let destobj;
    fromAddress(originRef.current.value)
      .then(({ results }) => {
        const { lat, lng } = results[0].geometry.location;
        originobj = {
          'lat': lat, 'lng': lng
        }
      })
      .catch(console.error);

    fromAddress(destiantionRef.current.value)
      .then(({ results }) => {
        const { lat, lng } = results[0].geometry.location;
        destobj = {
          'lat': lat, 'lng': lng
        }
      })
      .catch(console.error);
    //using ecode lib to get lat lng of origin func end

    // Calculate the center coordinates
    if (originobj && destobj) {
      const centerLat = (originobj.lat + destobj.lat) / 2;
      const centerLng = (originobj.lng + destobj.lng) / 2;

      // Set the center of the map
      setCenter({ lat: centerLat, lng: centerLng });
    }

    const directionsService = new window.google.maps.DirectionsService();
    const results = await directionsService.route({
      origin: originRef.current.value,

      destination: destiantionRef.current.value,
      travelMode: window.google.maps.TravelMode.DRIVING,
      unitSystem: countryLang === 'fr' ? window.google.maps.UnitSystem.METRIC : window.google.maps.UnitSystem.IMPERIAL,
    });
    setDirectionsResponse(results);
    setDistance(results.routes[0].legs[0].distance.text);
    setDuration(results.routes[0].legs[0].duration.text);


    /* const bearing = calculateBearing(
      results.routes[0].legs[0].start_location,
      results.routes[0].legs[0].end_location
    ); */

    const bearing = calculateBearing(
      results.routes[0].legs[0].start_location,
      results.routes[0].legs[0].end_location
    );

    const rotatepic = calculateRotation(
      originobj,
      results.routes[0].legs[0].start_location
    )

    // Set the appropriate car icon based on the bearing
    //setCarIcon(getCarIconByBearing(bearing));

    const startLocation = results.routes[0].legs[0].start_location;
    const endLocation = results.routes[0].legs[0].end_location;

    console.log(startLocation);

    const heading = window.google.maps.geometry.spherical.computeHeading(
      startLocation,
      endLocation
    );



    //const heading = results.routes[0].legs[0].steps[0].heading;
    console.log(bearing);
    console.log(`heading is ${heading}`);
    console.log(`rotate pic is ${rotatepic}`);

    //const imageIndex = Math.round((heading % 360 + 360) % 360);
    /* let angle;
    if (heading > 100 && heading < 132) {
      angle = 2;
    }
    if (heading > -3 && heading < -2) {
      angle = -75;
    }
    if (heading > 103 && heading < 104) {
      angle = -40;
    }
    if (heading > 118 && heading < 119) {
      angle = -70;
    }
    else { angle = heading; } */

    const imageIndex = Math.round(rotatepic);
    console.log(`imageindex is ${imageIndex}`);
    const carpic = await import(`./image/carimages/cardeg${imageIndex}.png`);
    setCarIcon(carpic.default);



    axios
      .post('https://dencityparking.azurewebsites.net/api/findlot/', {
        lat: results.routes[0].legs[0].end_location.lat(),
        lon: results.routes[0].legs[0].end_location.lng(),
      })
      .then((response) => {
        axios
          .get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${response.data.latitude},${response.data.longitude}&key=${api}`)
          .then((res) => {

            const formattedAddress = res.data.results[0].formatted_address;
            lotname = formattedAddress;
            /* setParkingLotName(formattedAddress);
            console.log(parkingLotName); */
            setName(formattedAddress);
            console.log(lotname);
            console.log(name);


          })
          .catch((error) => {
            console.error('Error fetching parking lot name:', error);
          });
        setParkingLot(response.data);

        setParkingLotCoordinates({
          lat: response.latitude,
          lng: response.data.longitude,
        });

        console.log(`cords are lat ${parkingLotCoordinates.lat}, long ${parkingLotCoordinates.lng} `);




      })
      .catch((error) => {
        console.error('Error fetching parking lot data:', error);
      });

    /* parkingLotPolygonCoords = [
      { lat: parkingLotCoordinates.lat, lng: parkingLotCoordinates.lng }, // Add parking lot coordinates
      // Add more coordinates to define the shape of the parking lot polygon
    ]; */

    /* const directionsService2 = new window.google.maps.DirectionsService();

    const results2 = await directionsService2.route({
      origin: originRef.current.value,
      waypoints: [{ location: destiantionRef.current.value, stopover: true }],
      destination: name,
      travelMode: window.google.maps.TravelMode.DRIVING,

    }); */






    setDirectionsParkingResponse(results);


    setDirectionsResponse(results);
    setDistance(results.routes[0].legs[0].distance.text);
    setDuration(results.routes[0].legs[0].duration.text);


  }

  function clearRoute() {
    setDirectionsResponse(null);
    setDirectionsParkingResponse(null);
    setDistance('');
    setDuration('');
    originRef.current.value = '';
    destiantionRef.current.value = '';
    setSrc();
    setDest();
    setParkingLot(null);
    setParkingLotCoordinates(null);
  }

  const handleMarkerClick = (parkingLot) => {
    setSelectedParkingLot(parkingLot);
  }

  const handleQuestionClick = (city) => {

    const bordeauxCenter = { lat: 44.836151, lng: -0.580816 };
    const newyorkCenter = { lat: 40.7128, lng: -74.00594 };

    if (city === "paris") {
      setCenter(center);
      setCountryLang('fr');
    }
    else if (city === "bordeaux") {
      setCenter(bordeauxCenter);
      setCountryLang('fr');
    }
    else if (city === "newyork") {
      setCenter(newyorkCenter);
      setCountryLang('us');
    }

    setQuestionaire(false);
  }

  //new code

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${currentLocation.lat},${currentLocation.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`)
          .then((res) => {
            const currentAddress = res.data.results[0].formatted_address;
            console.log(currentAddress);

            // Set the input field value with the current location
            originRef.current.value = currentAddress;
          })
          .catch((error) => {
            console.error("Error fetching geocode information:", error);
          });
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  //setting region boundary on autocomplete
  const parisBound = {
    north: 48.9021,
    south: 48.8156,
    east: 2.4699,
    west: 2.2241
  };

  const nyBound = {
    north: 40.9176,
    south: 40.4774,
    east: -73.7004,
    west: -74.2591
  };

  let region = countryLang === 'fr' ? parisBound : nyBound;


  var rotation = 0;

  var vehicon = {

    path: "M -53.582954,-415.35856 C -67.309015,-415.84417 -79.137232,-411.40275 -86.431515,-395.45159 L -112.76807,-329.50717 C -131.95714,-324.21675 -140.31066,-310.27864 -140.75323,-298.84302 L -140.75323,-212.49705 L -115.44706,-212.49705 L -115.44706,-183.44029 C -116.67339,-155.74786 -71.290042,-154.67757 -70.275134,-183.7288 L -69.739335,-212.24976 L 94.421043,-212.24976 L 94.956841,-183.7288 C 95.971739,-154.67759 141.39631,-155.74786 140.16998,-183.44029 L 140.16998,-212.49705 L 165.43493,-212.49705 L 165.43493,-298.84302 C 164.99236,-310.27864 156.63886,-324.21677 137.44977,-329.50717 L 111.11322,-395.45159 C 103.81894,-411.40272 91.990714,-415.84414 78.264661,-415.35856 L -53.582954,-415.35856 z M -50.57424,-392.48409 C -49.426163,-392.49037 -48.215854,-392.45144 -46.988512,-392.40166 L 72.082372,-392.03072 C 82.980293,-392.28497 87.602258,-392.03039 92.236634,-381.7269 L 111.19565,-330.61998 L -86.30787,-330.86727 L -67.554927,-380.61409 C -64.630656,-390.57231 -58.610776,-392.44013 -50.57424,-392.48409 z M -92.036791,-305.02531 C -80.233147,-305.02529 -70.646071,-295.47944 -70.646071,-283.6758 C -70.646071,-271.87217 -80.233147,-262.28508 -92.036791,-262.28508 C -103.84043,-262.28508 -113.42751,-271.87216 -113.42751,-283.6758 C -113.42751,-295.47946 -103.84043,-305.02531 -92.036791,-305.02531 z M 117.91374,-305.02531 C 129.71738,-305.02533 139.26324,-295.47944 139.26324,-283.6758 C 139.26324,-271.87216 129.71738,-262.28508 117.91374,-262.28508 C 106.1101,-262.28507 96.523021,-271.87216 96.523021,-283.6758 C 96.523021,-295.47944 106.1101,-305.02531 117.91374,-305.02531 z M 103.2216,-333.14394 L 103.2216,-333.14394 z M 103.2216,-333.14394 C 103.11577,-333.93673 102.96963,-334.55679 102.80176,-335.21316 C 101.69663,-339.53416 100.2179,-342.16153 97.043938,-345.3793 C 93.958208,-348.50762 90.488134,-350.42644 86.42796,-351.28706 C 82.4419,-352.13197 45.472822,-352.13422 41.474993,-351.28706 C 33.885682,-349.67886 27.380491,-343.34759 25.371094,-335.633 C 25.286417,-335.3079 25.200722,-334.40363 25.131185,-333.2339 L 103.2216,-333.14394 z M 64.176391,-389.01277 C 58.091423,-389.00227 52.013792,-385.83757 48.882186,-379.47638 C 47.628229,-376.92924 47.532697,-376.52293 47.532697,-372.24912 C 47.532697,-368.02543 47.619523,-367.53023 48.822209,-364.99187 C 50.995125,-360.40581 54.081354,-357.67937 59.048334,-355.90531 C 60.598733,-355.35157 62.040853,-355.17797 64.86613,-355.27555 C 68.233081,-355.39187 68.925861,-355.58211 71.703539,-356.95492 C 75.281118,-358.72306 77.90719,-361.35074 79.680517,-364.96188 C 80.736152,-367.11156 80.820083,-367.68829 80.820085,-372.0392 C 80.820081,-376.56329 80.765213,-376.87662 79.470596,-379.50637 C 76.3443,-385.85678 70.261355,-389.02327 64.176391,-389.01277 z",
    fillColor: '#FF0000',
    fillOpacity: .6,
    strokeWeight: 0,
    scale: .25,
    rotation: rotation
  }




  if (!isLoaded) {
    return <SkeletonText />;
  }


  if (questionaire === true) {
    return (


      <Question handleQuestionClick={handleQuestionClick} />




    )
  }




  else {
    return (
      <ChakraProvider theme={theme}>
        <Flex position="relative" flexDirection="column" alignItems="center" h="100vh" w="100vw">
          <Box position="absolute" left={0} top={0} h="96%" w="100%">
            <GoogleMap

              center={mapcenter}
              zoom={18}

              mapContainerStyle={{ width: '100%', height: '100%' }}
              options={{
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                styles: [
                  {
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#212121"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.icon",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                      {
                        "color": "#212121"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#000201"
                      },
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.country",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#bdbdbd"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#999EA4"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#999EA4"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                      {
                        "color": "#8a8a8a"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#000201"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                      {
                        "visibility": "off" //traffic light
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#999EA4"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#000201"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#000201"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#000201"
                      }
                    ]
                  },
                  {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#999EA4"
                      }
                    ]
                  },
                  {
                    "featureType": "transit",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "transit",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#000000"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#3d3d3d"
                      }
                    ]
                  }
                ]







              }}
              onLoad={(map) => {
                setMap(map);


              }}
            >

              {isLoaded && (
                <>
                  {/* Cluster for available parking lots */}
                  <MarkerClusterer options={{
                    styles: [
                      {
                        height: 33,
                        width: 33,
                        textColor: '#FFFFFF',
                        url: greenClustericon,
                      },
                    ],
                  }}>
                    {(clusterer) =>
                      availableparkingLots.map((parkingLot) => (
                        <Marker
                          //key={parkingLot.id}
                          position={{ lat: parseFloat(parkingLot.latitude), lng: parseFloat(parkingLot.longitude) }}
                          icon={parkingicon}
                          onClick={() => handleMarkerClick(parkingLot)}
                          clusterer={clusterer}
                          parkingLot={parkingLot}
                        />
                      ))
                    }
                  </MarkerClusterer>

                  {/* Cluster for unavailable parking lots */}
                  <MarkerClusterer options={{
                    styles: [
                      {
                        height: 33,
                        width: 33,
                        textColor: '#FFFFFF',
                        url: redClustericon,
                      },
                    ],
                  }}>
                    {(clusterer) =>
                      unavailableparkingLots.map((parkingLot) => (
                        <Marker
                          //key={parkingLot.id}
                          position={{ lat: parseFloat(parkingLot.latitude), lng: parseFloat(parkingLot.longitude) }}
                          icon={redparkingicon}
                          onClick={() => handleMarkerClick(parkingLot)}
                          clusterer={clusterer}
                          parkingLot={parkingLot}
                        />
                      ))
                    }
                  </MarkerClusterer>
                </>
              )}



              {
                privateParkingLots.map((parkingLot) => (
                  <Marker
                    //key={parkingLot.id}
                    position={{ lat: parseFloat(parkingLot.latitude), lng: parseFloat(parkingLot.longitude) }}
                    icon={{
                      url: privateparkingloticon,
                      scaledSize: new window.google.maps.Size(32, 32)
                    }}
                    onClick={() => handleMarkerClick(parkingLot)}

                  /* clusterer={clusterer}
                  parkingLot={parkingLot} */
                  />
                ))
              }









              {/* faltu tha ye
              {directionsResponse && !directionsParkingResponse && (
                <>
                  <DirectionsRenderer
                    directions={directionsResponse}
                    options={{
                      polylineOptions: {
                        strokeColor: '#F575791',
                        strokeWeight: 10,
                      },
                    }}
                  />
                  <Marker
                    position={{
                      lat: directionsResponse.routes[0].legs[0].start_location.lat(),
                      lng: directionsResponse.routes[0].legs[0].start_location.lng(),
                    }}

                  />
                  <Marker
                    position={{
                      lat: directionsResponse.routes[0].legs[0].end_location.lat(),
                      lng: directionsResponse.routes[0].legs[0].end_location.lng(),
                    }}

                  />
                </>
              )}

 */}

              {/*yehi code ha for direction from here IMPORTANT*/}
              {directionsParkingResponse &&

                <>
                  <DirectionsRenderer
                    directions={directionsResponse}
                    options={{
                      suppressMarkers: true,
                      polylineOptions: {
                        strokeColor: '#FF575791',
                        strokeWeight: 10,
                        optimizeWaypoints: false, // Disable default optimization
                        preserveViewport: true,
                      },
                    }}
                  />
                  <Marker
                    key="carmarker"
                    position={{
                      lat: directionsResponse.routes[0].legs[0].start_location.lat(),
                      lng: directionsResponse.routes[0].legs[0].start_location.lng(),
                    }}
                    icon={{
                      url: carIcon,
                      //scaledSize: new window.google.maps.Size(32, 32), // Adjust the size as needed
                      origin: new window.google.maps.Point(0, 0),
                      anchor: new window.google.maps.Point(16, 16), // Center of the image
                      //rotate: bearing
                      /*  rotation:
                         window.google.maps.geometry.spherical.computeHeading(
                           directionsResponse.routes[0].legs[0].start_location,
                           directionsResponse.routes[0].legs[0].end_location
                         ) */


                    }}

                  />
                  <Marker
                    position={{
                      lat: directionsResponse.routes[0].legs[0].end_location.lat(),
                      lng: directionsResponse.routes[0].legs[0].end_location.lng(),
                    }}

                  />
                </>


              }

              {parkingLot && parkingLotCoordinates && (
                <>
                  <Polygon
                    paths={parkingLotCoords}
                    // Use the coordinates for the parking lot polygon parking lot k liye tha
                    options={{
                      fillColor: 'rgba(255, 0, 0, 0.2)', // Fill color
                      strokeColor: 'red', // Border color
                      strokeOpacity: 5, // Border opacity
                      strokeWeight: 5, // Border width
                    }}
                  />
                  <Marker
                    position={parkingLotCoordinates}
                    label="P"
                    title="Parking Lot"
                    icon={"https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png"}
                    onClick={(e) => handleMarkerClick(parkingLot)}
                  />
                  {/*   {directionsResponse && parkingLotCoordinates && (
                <Polyline
                  path={[
                    {
                      lat: directionsResponse.routes[0].legs[0].end_location.lat(),
                      lng: directionsResponse.routes[0].legs[0].end_location.lng(),
                    },
                    parkingLotCoordinates,
                  ]}
                  options={{
                    strokeColor: 'green', // Change color to yellow
                    strokeWeight: 8, // Change the line width
                  }}
                />
              )} */}
                </>
              )}
              {/*till here^*/}

              {/*yehi code use ma ha markers dhekana k liye sare lekun cluster k liye comment out*/}

              {/*  {parkingLots.map((parkingLot) => (
              <Marker
                key={parkingLot.id}
                position={{ lat: parseFloat(parkingLot.latitude), lng: parseFloat(parkingLot.longitude) }}
                icon={parkingicon}
                onClick={() => handleMarkerClick(parkingLot)}
              />
            ))} */}

              {selectedParkingLot && (
                <InfoWindow
                  position={{
                    lat: parseFloat(selectedParkingLot.latitude),
                    lng: parseFloat(selectedParkingLot.longitude),
                  }}
                  onCloseClick={() => setSelectedParkingLot(null)}
                >
                  <div>
                    <h3>Parking Lot Details</h3>
                    <p>ID: {selectedParkingLot.id}</p>
                    <p>Status: {selectedParkingLot.status ? "Available" : "Not Available"}</p>
                    <p>Latitude: {selectedParkingLot.latitude}</p>
                    <p>Longitude: {selectedParkingLot.longitude}</p>
                    {/* Add more details here */}
                  </div>
                </InfoWindow>
              )}

            </GoogleMap>
            <footer></footer>
          </Box>


          <Box minW={{ base: '90%', md: 'container.md' }} flexShrink={2} p={4} borderRadius="lg" m={4} bgColor="black" shadow="base" /* minW="container.md" */ zIndex="1">
            <Stack direction={{ base: 'column', md: 'row' }} flexShrink={2} spacing={3} justifyContent="space-between">
              <Box flexGrow={1} flexShrink={2}>
                <Autocomplete

                  options={{
                    componentRestrictions: { country: countryLang },
                    strictBounds: true,
                    bounds: region
                  }}
                >
                  <Box position="relative">
                    <InputGroup>
                      <Input
                        _focus={{ outlineColor: 'none' }}
                        _active={{ outlineColor: 'none' }}
                        color="white"
                        type="text"
                        placeholder={countryLang === 'fr' ? 'Origine' : 'Origin'}
                        ref={originRef}
                        value={querysrc}
                        onChange={(e) => { setSrc(e.current.value) }}
                      />
                      <InputRightElement position="absolute" right="5px">
                        <IconButton
                          aria-label="Current Location"
                          icon={<img src={locicon} width={10} />}
                          variant="ghost"
                          _hover={{ color: 'black' }}
                          _focus={{ color: 'black' }}
                          _active={{ color: 'black' }}
                          onClick={handleGetCurrentLocation}
                        />
                      </InputRightElement>
                    </InputGroup>
                  </Box>
                </Autocomplete>
              </Box>
              <Box flexGrow={1}>
                <Autocomplete

                  options={{
                    componentRestrictions: { country: countryLang },
                    strictBounds: true,
                    bounds: region
                  }}>
                  <Input _focus={{ outlineColor: 'none' }}
                    _active={{ outlineColor: 'none' }} color="white" type="text" placeholder="Destination" ref={destiantionRef} value={querydest} onChange={(e) => { setDest(e.current.value) }} />
                </Autocomplete>
              </Box>
              <ButtonGroup justifyContent={{ base: 'flex-end', md: 'flex-start' }}  >
                <Button _focus={{ color: 'red' }} maxW={{ base: '30px', md: '80px' }}
                  _active={{ color: 'red' }} id='findbtn' type="submit" onClick={calculateRoute} order={{ base: 1, md: 0 }} ml={{ base: 2, md: 0 }}>
                  Find
                </Button>

                {/* <IconButton
                  _active={{ backgroundColor: 'red' }}
                  aria-label="center back"
                  icon={<FaLocationArrow />}
                  isRound
                  onClick={() => {
                    map.panTo(mapcenter);
                    map.setZoom(15);
                  }}
                /> */}

                <IconButton
                  aria-label="center back"
                  icon={<FaTimes />}
                  onClick={clearRoute}
                  order={{ base: 0, md: 1 }}
                  mr={{ base: 2, md: 0 }}
                  maxW={{ base: '30px', md: '80px' }}
                />

              </ButtonGroup>
            </Stack>
            {distance &&
              <HStack spacing={{ base: 1, md: 2 }} mt={{ base: -12, md: 4 }} mb={{ base: 3 }} maxW={{ base: '70%' }} >
                {/* <Text color={"white"} >Distance: {distance} </Text>
                <Text color={"white"} >Duration: {duration} </Text> */}
                <Box display="flex" alignItems="center">
                  <Image src={distanceIcon} alt="Distance Icon" /* boxSize="24px" */ boxSize={{ base: '18px', md: '24px' }} />
                  <Text color="white" ml={2}>{distance}</Text>
                </Box>
                <Box display="flex" alignItems="center">
                  <Image src={durationIcon} alt="Duration Icon" /* boxSize="24px" */ boxSize={{ base: '18px', md: '24px' }} />
                  <Text color="white" ml={2}>{duration} </Text>
                </Box>

                {/* <IconButton
                  aria-label="center back"
                  icon={<FaTimes />}
                  onClick={clearRoute}
                /> */}
              </HStack>}
          </Box>


        </Flex>
        {/* <footer></footer> */}
      </ChakraProvider>
    );

  }
}

export default App;
